import type {
  ResetPasswordCommand,
  ResetPasswordResult,
} from "../model/PasswordReset";
import type { PasswordResetService } from "../port/PasswordResetService";

export class ResetPassword {
  constructor(private readonly service: PasswordResetService) {}

  execute(
    cmd: ResetPasswordCommand,
    signal?: AbortSignal,
  ): Promise<ResetPasswordResult> {
    return this.service.resetPassword(cmd, signal);
  }
}
